import { render, staticRenderFns } from "./edit-service-booking.vue?vue&type=template&id=fdfed3ca&"
import script from "./edit-service-booking.vue?vue&type=script&lang=js&"
export * from "./edit-service-booking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports